import {store} from '../../redux/store';
import {modalTypes} from '../../utils/enums';
import {QuestionModalMessage} from '../../interfaces/connected-components/questionModal';
import {hideQuestionModal, showQuestionModal} from './reducer';

/**
 * This function open Question modal
 */
export const openQuestionModal = ({
  message,
  title = '',
  type = modalTypes.question,
  onConfirm,
  confirmText,
  onReject,
  rejectText,
  customHeaderComponent,
}: QuestionModalMessage) => {
  store.dispatch(
    showQuestionModal({
      message,
      title,
      type,
      onConfirm,
      confirmText,
      onReject,
      rejectText,
      customHeaderComponent,
    }),
  );
};

/**
 * This function close Question modal
 */
export const closeQuestionModal = () => {
  store.dispatch(hideQuestionModal());
};
